import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import PendingOutlinedIcon from '@mui/icons-material/PendingOutlined';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import RemoveCircleOutlinedIcon from '@mui/icons-material/RemoveCircleOutlined';
import { StatusBadge } from './styles';

const statusConfig = {
  active: { icon: <CheckCircleOutlinedIcon />, label: "Active", color: "#10b981" },
  approved: { icon: <CheckCircleOutlinedIcon />, label: "Approved", color: "#10b981" },
  pending: { icon: <PendingOutlinedIcon />, label: "Pending", color: "#f59e0b" },
  unlisted: { icon: <PendingOutlinedIcon />, label: "Unlisted", color: "#f59e0b" },
  deprecated: { icon: <RemoveCircleOutlinedIcon />, label: "Deprecated", color: "#6b7280" },
  rejected: { icon: <CancelOutlinedIcon />, label: "Rejected", color: "#ef4444" },
  revoked: { icon: <CancelOutlinedIcon />, label: "Revoked", color: "#ef4444" },
};

export default function Status({ status, noBorder }: { status: any; noBorder?: boolean }) {
  return (
    <StatusBadge status={status} noBorder={noBorder}>
      {statusConfig[status as keyof typeof statusConfig].icon}
      {statusConfig[status as keyof typeof statusConfig].label}
    </StatusBadge>
  );
}